import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import Popover from '@mui/material/Popover';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import Card from '@mui/material/Card';
import MDBox from 'components/material/MDBox';

import useMembers from 'hooks/useMembers';
import { useNavigate } from 'react-router-dom';
import BasicTable from 'components/common/Table';
import { useSelector } from 'react-redux';
import { UserRoles } from 'constants/UserRoles';
import TbaleHeader from './TableHeader';
import { useDeleteUserMutation } from 'api/user';
import MDButton from 'components/material/MDButton';
import MDTypography from 'components/material/MDTypography';

function Projects() {
  const [deleteDialog, setDeleteDialog] = useState({ open: false, user: null });
  const [anchorEl, setAnchorEl] = useState(null);
  const [popoverContent, setPopoverContent] = useState('');

  const navigate = useNavigate();
  const { user } = useSelector((state) => state.auth);
  const [deleteUser, info] = useDeleteUserMutation();

  const handleRegionHover = (event, content) => {
    setAnchorEl(event ? event.currentTarget : null);
    setPopoverContent(content);
  };

  const handleDeleteUser = (user) => {
    setDeleteDialog({ open: true, user });
  };

  const handleDeleteConfirm = (withEntry) => {
    deleteUser({ id: deleteDialog.user.id, body: { withEntry } });
  };

  const handleDeleteCancel = () => {
    setDeleteDialog({ open: false, user: null });
  };

  const { columns, rows, isLoading, totalMembers } = useMembers(
    (user) => handleDeleteUser(user),
    handleRegionHover
  );

  useEffect(() => {
    if (info.isSuccess) toast.success('Membru sters cu succes!');
    if (info.isError) toast.error('A aparut o problema, va rugam incercati mai tarziu');
    setDeleteDialog({ open: false, user: null });
  }, [info]);

  useEffect(() => {
    if (!user) return navigate('/authentication/signin');
    if (user.roles.map((ur) => ur.role).includes(UserRoles.Member)) {
      navigate('/dashboard/general');
    }
  }, [user]);

  const DeleteConfirmationDialog = () => (
    <Dialog open={deleteDialog.open} onClose={handleDeleteCancel}>
      <DialogTitle>Confirmare ștergere membru</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Adaugati o inregistrare tip "iesire sindicat" in registru?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <MDButton onClick={() => handleDeleteConfirm(true)} color="primary">
          Da
        </MDButton>
        <MDButton onClick={() => handleDeleteConfirm(false)} color="error">
          Nu, doar sterge membru
        </MDButton>
      </DialogActions>
    </Dialog>
  );

  if (isLoading) return <p>Loading ...</p>;

  return (
    <Card>
      <TbaleHeader />
      <MDBox px={3} pb={3}>
        <MDTypography variant="button" color="text">
          Total membri înregistrați: <strong>{totalMembers}</strong>
        </MDTypography>
      </MDBox>
      <DeleteConfirmationDialog />
      <MDBox>
        <BasicTable
          usersTable={true}
          pageSize={300}
          rows={rows}
          columns={columns}
          striped={true}
          hover={true}
        />
      </MDBox>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MDBox p={2}>
          <MDTypography variant="button">{popoverContent}</MDTypography>
        </MDBox>
      </Popover>
    </Card>
  );
}

export default Projects;
